<template>
    <div class="group relative">
        <svg
            viewBox="0 0 119 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="119"
            height="75"
            class="transition-transform duration-300 group-hover/menuItem:translate-x-10">
            <rect
                x="48"
                y="12"
                transform="rotate(90 48 12)"
                stroke="currentColor"
                stroke-width="2"
                width="12"
                height="7" />
            <mask
                id="path-2-inside-1_8066_6102"
                fill="white">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M96.6665 32.6328L105.004 24.3402C106.57 22.7823 106.57 20.2565 105.004 18.6987L100.251 13.9716C98.6851 12.4138 96.1456 12.4138 94.5793 13.9716L85.5018 23.0001H35.6665C33.4574 23.0001 31.6665 24.7909 31.6665 27.0001V66.0001C31.6665 68.2092 33.4574 70.0001 35.6665 70.0001H44.3534V71.0001C44.3534 73.2092 46.1443 75.0001 48.3534 75.0001H79.3279C81.5371 75.0001 83.3279 73.2092 83.3279 71.0001V70.0001H92.6665C94.8756 70.0001 96.6665 68.2092 96.6665 66.0001V32.6328Z" />
            </mask>
            <path
                d="M96.6665 32.6328L95.2561 31.2148L94.6665 31.8012V32.6328H96.6665ZM105.004 24.3402L106.415 25.7582L106.415 25.7582L105.004 24.3402ZM105.004 18.6987L103.594 20.1167V20.1167L105.004 18.6987ZM100.251 13.9716L101.662 12.5536V12.5536L100.251 13.9716ZM94.5793 13.9716L95.9897 15.3897V15.3897L94.5793 13.9716ZM85.5018 23.0001V25.0001H86.3271L86.9122 24.4181L85.5018 23.0001ZM44.3534 70.0001H46.3534V68.0001H44.3534V70.0001ZM83.3279 70.0001V68.0001H81.3279V70.0001H83.3279ZM98.0769 34.0509L106.415 25.7582L103.594 22.9222L95.2561 31.2148L98.0769 34.0509ZM106.415 25.7582C108.767 23.4184 108.767 19.6204 106.415 17.2806L103.594 20.1167C104.374 20.8927 104.374 22.1462 103.594 22.9222L106.415 25.7582ZM106.415 17.2806L101.662 12.5536L98.8411 15.3897L103.594 20.1167L106.415 17.2806ZM101.662 12.5536C99.3153 10.2198 95.5154 10.2198 93.1689 12.5536L95.9897 15.3897C96.7758 14.6077 98.0549 14.6077 98.8411 15.3897L101.662 12.5536ZM93.1689 12.5536L84.0914 21.582L86.9122 24.4181L95.9897 15.3897L93.1689 12.5536ZM85.5018 21.0001H35.6665V25.0001H85.5018V21.0001ZM35.6665 21.0001C32.3528 21.0001 29.6665 23.6864 29.6665 27.0001H33.6665C33.6665 25.8955 34.5619 25.0001 35.6665 25.0001V21.0001ZM29.6665 27.0001V66.0001H33.6665V27.0001H29.6665ZM29.6665 66.0001C29.6665 69.3138 32.3528 72.0001 35.6665 72.0001V68.0001C34.5619 68.0001 33.6665 67.1047 33.6665 66.0001H29.6665ZM35.6665 72.0001H44.3534V68.0001H35.6665V72.0001ZM42.3534 70.0001V71.0001H46.3534V70.0001H42.3534ZM42.3534 71.0001C42.3534 74.3138 45.0397 77.0001 48.3534 77.0001V73.0001C47.2489 73.0001 46.3534 72.1046 46.3534 71.0001H42.3534ZM48.3534 77.0001H79.3279V73.0001H48.3534V77.0001ZM79.3279 77.0001C82.6416 77.0001 85.3279 74.3138 85.3279 71.0001H81.3279C81.3279 72.1046 80.4325 73.0001 79.3279 73.0001V77.0001ZM85.3279 71.0001V70.0001H81.3279V71.0001H85.3279ZM83.3279 72.0001H92.6665V68.0001H83.3279V72.0001ZM92.6665 72.0001C95.9802 72.0001 98.6665 69.3138 98.6665 66.0001H94.6665C94.6665 67.1047 93.7711 68.0001 92.6665 68.0001V72.0001ZM98.6665 66.0001V32.6328H94.6665V66.0001H98.6665Z"
                fill="currentColor"
                mask="url(#path-2-inside-1_8066_6102)" />
            <rect
                x="37.6665"
                y="29"
                rx="3"
                stroke="currentColor"
                stroke-width="2"
                width="53"
                height="35" />
            <path
                d="M2.02393 27.124H12.0083C12.2182 27.1241 12.422 27.19 12.5913 27.3115L12.6616 27.3672L23.1157 36.3945C23.3356 36.5844 23.4623 36.8609 23.4624 37.1514V55.5459C23.4624 55.8001 23.3654 56.0435 23.1938 56.2275L23.1157 56.3027L12.6616 65.3301C12.48 65.4869 12.2482 65.5732 12.0083 65.5732H2.02393C1.47164 65.5732 1.02393 65.1255 1.02393 64.5732V28.124C1.02393 27.5717 1.47164 27.124 2.02393 27.124Z"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M32.8889 40.4497H95.2485"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M11.8218 26.9663L11.8218 65.7304"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M98.1421 4.37831L96.0892 6.43127C95.6585 6.8619 95.3706 7.41219 95.2605 8.00706L95.2239 8.26463L94.5872 14.8509C94.5011 15.7431 94.8187 16.6278 95.4525 17.2616L101.721 23.5303C102.315 24.1244 103.13 24.4396 103.964 24.4059L104.131 24.3948L110.718 23.7588C111.411 23.6919 112.059 23.3857 112.551 22.8936L114.604 20.8406C115.776 19.6691 115.776 17.7696 114.604 16.598L102.385 4.37831C101.25 3.24333 99.4316 3.20788 98.254 4.27197L98.1421 4.37831Z"
                fill="white"
                stroke="currentColor"
                stroke-width="2" />
            <rect
                x="49.6665"
                y="33"
                rx="3"
                fill="white"
                stroke="currentColor"
                stroke-width="2"
                width="7"
                height="26" />
            <rect
                x="23.6665"
                y="34"
                rx="1"
                stroke="currentColor"
                stroke-width="2"
                width="9"
                height="25" />
            <rect
                x="33.0464"
                y="1"
                rx="3"
                stroke="currentColor"
                stroke-width="2"
                width="48.5618"
                height="10.6405" />
        </svg>

        <svg
            viewBox="0 0 39 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="59"
            class="absolute top-10 mt-5 opacity-0 transition-all duration-300 group-hover/menuItem:animate-waves-sound-left group-hover/menuItem:opacity-100">
            <path
                d="M0 0L39 10V49L0 59V0Z"
                fill="url(#paint0_linear_8066_6196)" />
            <defs>
                <linearGradient
                    id="paint0_linear_8066_6196"
                    x1="39"
                    y1="29.5"
                    x2="0"
                    y2="29.5"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#E0D4F6" />
                    <stop
                        offset="1"
                        stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>
